import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import Forside from "./pages/Forside";
import Toemrerarbejde from "./pages/Toemrerarbejde";
import Terrasse from "./pages/Terrasse";
import Tagarbejde from "./pages/Tagarbejde";
import MurerBelaegning from "./pages/MurerBelaegning";
import OmOs from "./pages/OmOs";
import Kontakt from "./pages/Kontakt";

function App() {
  return (
    <div className="min-h-screen flex flex-col bg-zinc-950 text-stone-100 antialiased selection:bg-amber-800 selection:text-stone-50">
      {/* Scroll Restoration */}
      <ScrollToTop />

      {/* Navigation Header */}
      <Header />

      {/* Main Content Area */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Forside />} />
          <Route path="/toemrerarbejde" element={<Toemrerarbejde />} />
          <Route path="/terrasse" element={<Terrasse />} />
          <Route path="/tagarbejde" element={<Tagarbejde />} />
          <Route path="/murer-belaegning" element={<MurerBelaegning />} />
          <Route path="/om-os" element={<OmOs />} />
          <Route path="/kontakt" element={<Kontakt />} />
          {/* Fallback route */}
          <Route path="*" element={<Forside />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
